module.exports = __webpack_public_path__ + "img/cloth_g3_shirt-06.058893b2.svg";